var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin 1",
    clipPath: "url(#clip0_248_859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.70744 5.11914H0.537109V14.491H3.70744V5.11914Z",
    fill: "#133A25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3434 5.22905C12.3097 5.21882 12.2778 5.20775 12.2423 5.19838C12.1998 5.189 12.1573 5.18134 12.1139 5.17452C11.9455 5.14214 11.7612 5.11914 11.545 5.11914C9.69669 5.11914 8.52443 6.4116 8.1381 6.91086V5.11914H4.96777V14.491H8.1381V9.37906C8.1381 9.37906 10.534 6.17049 11.545 8.52707C11.545 10.6306 11.545 14.491 11.545 14.491H14.7145V8.16668C14.7145 6.75069 13.7052 5.57069 12.3434 5.22905Z",
    fill: "#133A25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.08772 3.84132C2.9441 3.84132 3.63833 3.17379 3.63833 2.35035C3.63833 1.52691 2.9441 0.859375 2.08772 0.859375C1.23134 0.859375 0.537109 1.52691 0.537109 2.35035C0.537109 3.17379 1.23134 3.84132 2.08772 3.84132Z",
    fill: "#133A25"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.177,
    height: 13.6317,
    fill: "#133A25",
    transform: "translate(0.537109 0.859375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3d44f60f90c98b48cde5e05737823598.svg";
export { ForwardRef as ReactComponent };